import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Grid, makeStyles, Checkbox } from "@material-ui/core";
import { useHistory } from "react-router-dom";

import CustomTextField from "../../common-components/CustomTextField";
import LoginScreenBanner from "../../shared-resources/images/LeftPanelLoginScreens.png";
import { validateEmail } from "../../shared-resources/utils";
import { login } from "../../actions/admin-actions";
import Loading from "../../common-components/Loading";
import ActionMessages from "../../common-components/ActionMessages";
import AuthWrapper from "./authWrapper";

function Login() {
  const isForgotPassChanged = useSelector(
    (state) => state.forgotPasswordReducer.isPassChanged,
  );

  const history = useHistory();
  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoginClicked, setIsLoginClicked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [emptyErrMsg, setEmptyErrMsg] = useState(false);
  const [isAzure, setIsAzure] = useState(false);
  const [msgType, setMsgType] = useState();
  const [msgText, setMsgText] = useState();

  const loginData = useSelector((state) => state.adminReducer.loginData);

  const useStyles = makeStyles((theme) => ({
    "@global": {
      body: {
        overflow: "hidden",
      },
    },
    loginwrapper: {
      background: "#fff",
      textAlign: "center",
    },
    fieldStyle: {
      width: "60%",
      margin: "8px auto",
    },
    welcomeHead: {
      fontSize: theme.spacing(3),
      letterSpacing: "0px",
      color: "#3D3D3D",
      opacity: "1",
      marginBottom: theme.spacing(1.5),
      fontWeight: 600,
    },

    loginNote: {
      fontSize: theme.spacing(1.75),
      letterSpacing: "0px",
      marginBottom: theme.spacing(1.5),
    },

    welcomeWrapper: {
      marginTop: !isAzure ? "6%" : "6%",
    },
    loginBtn: {
      textTransform: "none",
      borderRadius: theme.spacing(3),
      background: "#0176D3 !important",
      fontWeight: 500,
      width: "60%",
      marginTop: theme.spacing(4),
      padding: "12px 0 !important",
    },
    fieldsGrid: {
      position: "relative",
    },
    bannerSection: {
      background: "#2354E8",
    },
    loginGrid: {
      height: window.innerHeight + 32,
    },
    loginBanner: {
      marginTop: "45%",
    },
    forgotPswLink: {
      color: "#3D3D3D !important",
      cursor: "pointer",
    },
  }));
  const classes = useStyles();

  const emailChange = (e) => {
    localStorage.setItem("emailid", e.target.value);
    setEmail(e.target.value);
  };

  const passwordsChange = (e) => {
    setPassword(e.target.value);
  };

  const isClosed = (val) => {
    setEmptyErrMsg(!val);
  };

  const handleForgotPassword = (e) => {
    history.push("/emailverify");
  };

  const proceedLogin = (e) => {
    e.preventDefault();
    localStorage.setItem("isAzure", isAzure);
    setIsLoginClicked(true);
    if (email.trim() === "") {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(`Please enter email`);
      return;
    }
    if (password.trim() === "") {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(`Please enter password`);
      return;
    }
    if (!validateEmail(email)) {
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(`Please enter valid email`);
      return;
    }
    if (password !== "" && email !== "" && validateEmail(email)) {
      dispatch(login({ username: email, password: password }, isAzure));
      setLoading(true);
    }
  };

  useEffect(() => {
    if (loginData && loginData.status === 200) {
      setLoading(false);
      const data = loginData.data;
      if (data.Role) {
        const roles = data.Role;
        localStorage.setItem("token", data["Access Token"]);
        localStorage.setItem("Is_Loggedin", true);
        localStorage.setItem("Login_User_Name", data.Name);
        localStorage.setItem("Last_Login_Time", new Date());
        localStorage.setItem("roles", JSON.stringify(roles));
        localStorage.setItem("email", data.Email);
        localStorage.setItem("employeeId", data.empId);
        console.log(data);
        localStorage.setItem("accessType", data.accessType);
        if (data.Module) localStorage.setItem("module", data.Module);
        if (roles.includes("SU")) localStorage.setItem("isSuperUser", true);
        else localStorage.setItem("isSuperUser", false);
        if (
          roles.includes("PC") ||
          roles.includes("DPM") ||
          roles.includes("PM") ||
          roles.includes("OV") ||
          roles.includes("SU")
        )
          window.location.assign("/projects/financial-dashboard");
      } else {
        setEmptyErrMsg(true);
        setMsgType("error");
        setMsgText(`Please enter a valid email and password`);
      }
    }
  }, [loginData]);
  useEffect(() => {
    if (loginData && loginData.status === 400) {
      setLoading(false);
      setEmptyErrMsg(true);
      setMsgType("error");
      setMsgText(loginData.message);
    }
  }, [loginData]);

  useEffect(() => {
    localStorage.setItem("emailid", email);
    console.log(email, "emaildId123");
    const isLoggedIn = localStorage.getItem("Is_Loggedin");
    if (isLoggedIn) window.location.assign("/");
    //if (process.env.IS_PROD) window.location.assign("/sso");
  }, []);

  const onClickNewUser = () => {
    history.push("/create-user");
  };

  useEffect(() => {
    if (isForgotPassChanged) {
      setEmptyErrMsg(true);
      setMsgType("success");
      setMsgText(`Password changed successfully!`);
    }
  }, []);

  return (
    <>
      <AuthWrapper loading={loading}>
        <Grid item lg={12} className={classes.welcomeHead}>
          <span>Welcome to Financial Clarity</span>
        </Grid>
        <Grid item lg={12} className={classes.loginNote}>
          Please login to your account
        </Grid>
        <Grid item lg={12}>
          <div className={classes.fieldStyle}>
            <CustomTextField
              selectedValue={email}
              onChangeItem={emailChange}
              labelVal="Email ID"
              id="emailId"
              errorValue={
                (isLoginClicked && email === "") ||
                (isLoginClicked && !validateEmail(email))
              }
              isLoginField={true}
            />
          </div>
        </Grid>
        <Grid item lg={12}>
          <div className={classes.fieldStyle}>
            <CustomTextField
              selectedValue={password}
              onChangeItem={passwordsChange}
              labelVal="Password"
              id="password"
              errorValue={isLoginClicked && password === ""}
              type="password"
              isLoginField={true}
            />
          </div>
        </Grid>
        <Grid item lg={2} />
        <Grid item lg={8} style={{ textAlign: "right", paddingRight: "32px" }}>
          {/* <span style={{ float: "left" }}>
                        <Checkbox
                          className="customCheckBox"
                          checked={isAzure}
                          color="primary"
                          onClick={() => setIsAzure(!isAzure)}
                        />
                      </span>
                      <span style={{ float: "left", marginTop: "2px" }}>
                        Is Azure?
                      </span>*/}
          <a onClick={handleForgotPassword} className={classes.forgotPswLink}>
            Change/Forgot Password
          </a>
        </Grid>
        <Grid item lg={12}>
          <Button
            m={3}
            variant="contained"
            color="primary"
            disableElevation
            className={classes.loginBtn}
            onClick={proceedLogin}
            type="submit"
          >
            Login
          </Button>
        </Grid>
        {/*{!isAzure && (
                      <>
                        <Grid item lg={12} style={{ margin: "12px 0" }}>
                          <span style={{ fontSize: "18px" }}>OR</span>
                        </Grid>
                        <Grid item lg={12} style={{ margin: "2px 0" }}>
                          <span
                            style={{
                              color: "#09659C",
                              fontWeight: 600,
                              cursor: "pointer",
                            }}
                            onClick={onClickNewUser}
                          >
                            Create New User
                          </span>
                        </Grid>
                      </>
                    )}*/}
      </AuthWrapper>
      {emptyErrMsg && (
        <ActionMessages type={msgType} isClosed={isClosed} message={msgText} />
      )}
    </>
  );
}

export default Login;
